import {
    SET_LIMIT_ACCESS_FIRE_TV,
    SET_APP_TYPE,
    SET_DEVICE_CAPABILITIES,
    SET_IS_APP_VIEW,
} from "actions/types";

const initialState = {
    limitAccessFireTv: false,
    appType: null,
    deviceCapabilities: null,
    isAppView: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_LIMIT_ACCESS_FIRE_TV:
            return {
                ...state,
                limitAccessFireTv: payload,
            };
        case SET_APP_TYPE:
            return {
                ...state,
                appType: payload,
            };
        case SET_DEVICE_CAPABILITIES:
            return {
                ...state,
                deviceCapabilities: payload,
            };
        case SET_IS_APP_VIEW:
            return {
                ...state,
                isAppView: payload,
            };
        default:
            return state;
    }
}